export default __webpack_public_path__ + "static/media/Capture.212eae5d.webp";